//
// Migration Processor for Autentikar to FaceTec migration
// Performs 3D Liveness + 3D-to-2D Match against pre-existing S3 enrollment image
//
import { Config } from "../../Config";
import { FaceTecSDK } from "../../../core-sdk/FaceTecSDK.js/FaceTecSDK";
var MigrationProcessor = /** @class */ (function () {
    function MigrationProcessor(demonstrationExternalDatabaseRefID, enrollmentImageBase64, onCompleteCallback) {
        var _this = this;
        //
        // Part 2: Handling the Result of the Migration Flow
        //
        this.onSessionRequest = function (requestBlob, requestCallback) {
            console.log('🔄 [Migration] Iniciando procesamiento de migración Autentikar');
            if (window.updateStepperProgress) {
                window.updateStepperProgress(2);
            }
            // Create payload with migration-specific fields
            var migrationPayload = {
                requestBlob: requestBlob,
                externalDatabaseRefID: _this.demonstrationExternalDatabaseRefID,
                enrollmentImageBase64: _this.enrollmentImageBase64,
                isMigration: true
            };
            console.log('📋 [Migration] Payload preparado:', {
                externalDatabaseRefID: _this.demonstrationExternalDatabaseRefID,
                requestBlobLength: requestBlob.length,
                enrollmentImageBase64Length: _this.enrollmentImageBase64.length,
                isMigration: true
            });
            // Send request to middleware
            _this.sendMigrationRequest(migrationPayload, requestCallback);
        };
        this.sendMigrationRequest = function (payload, requestCallback) {
            var request = new XMLHttpRequest();
            // Extraer parámetros de validación desde la URL
            var urlParams = new URLSearchParams(window.location.search);
            var expectedDocumentType = urlParams.get('expectedDocumentType');
            var country = urlParams.get('country');
            // Construir endpoint
            var fullEndpoint = Config.YOUR_API_OR_FACETEC_TESTING_API_ENDPOINT + '/process-request';
            if (expectedDocumentType || country) {
                var queryParams = new URLSearchParams();
                if (expectedDocumentType)
                    queryParams.append('expectedDocumentType', expectedDocumentType);
                if (country)
                    queryParams.append('country', country);
                fullEndpoint += "?".concat(queryParams.toString());
            }
            console.log('🌐 [Migration] Enviando a:', fullEndpoint);
            request.open('POST', fullEndpoint);
            request.setRequestHeader("Content-Type", "application/json");
            request.setRequestHeader("X-Device-Key", Config.DeviceKeyIdentifier);
            request.setRequestHeader("X-Testing-API-Header", FaceTecSDK.getTestingAPIHeader());
            request.onload = function () {
                switch (request.status) {
                    case 200:
                        try {
                            console.log('✅ [Migration] Respuesta exitosa recibida');
                            var parsedResponse = JSON.parse(request.responseText);
                            var responseBlob = parsedResponse.responseBlob;
                            console.log('📥 [Migration] Procesando respuesta:', {
                                hasResponseBlob: !!responseBlob,
                                responseBlobLength: (responseBlob === null || responseBlob === void 0 ? void 0 : responseBlob.length) || 0,
                                hasValidation: !!parsedResponse.validation
                            });
                            // Guardar validación si existe
                            if (parsedResponse.validation) {
                                console.log('🔍 [Migration] Validación recibida:', parsedResponse.validation);
                                window.faceTecValidationData = parsedResponse.validation;
                            }
                            requestCallback.processResponse(responseBlob);
                        }
                        catch (e) {
                            console.error('❌ [Migration] Error al parsear respuesta:', e);
                            requestCallback.abortOnCatastrophicError();
                        }
                        break;
                    default:
                        console.error("\u274C [Migration] Error del servidor - Status: ".concat(request.status));
                        requestCallback.abortOnCatastrophicError();
                }
            };
            request.onerror = function (ev) {
                console.error('❌ [Migration] Error catastrófico de red:', ev);
                requestCallback.abortOnCatastrophicError();
            };
            request.upload.onprogress = function (ev) {
                var progress = Math.round((ev.loaded / ev.total) * 100);
                console.log("\uD83D\uDCCA [Migration] Progreso de upload: ".concat(progress, "%"));
                requestCallback.updateProgress(ev.loaded / ev.total);
            };
            console.log('📤 [Migration] Enviando payload de migración');
            request.send(JSON.stringify(payload));
        };
        // Session is completely done
        this.onFaceTecExit = function (faceTecSessionResult) {
            console.log('🏁 [Migration] Migración completada');
            console.log('📊 [Migration] Status:', faceTecSessionResult.status);
            console.log('📄 [Migration] Resultado completo:', faceTecSessionResult);
            _this.onCompleteCallback(faceTecSessionResult.status);
        };
        this.demonstrationExternalDatabaseRefID = demonstrationExternalDatabaseRefID;
        this.enrollmentImageBase64 = enrollmentImageBase64;
        this.onCompleteCallback = onCompleteCallback;
    }
    return MigrationProcessor;
}());
export { MigrationProcessor };
